import type { Meta, Link, HtmlAttributes } from 'unhead/types'
import type { HeadInfo } from '~/modules/head/entities/HeadInfo'
import { LangList } from '~/modules/lang/entities/Lang'

export const useHeadInfoComposable = () => {
  const getHeadInfoShortDescription = (headInfo: HeadInfo): HeadInfo => {
    const maxDescriptionCharacters = 160

    if (
      headInfo.description &&
      headInfo.description.length > maxDescriptionCharacters
    ) {
      const fullDescription = headInfo.description
      const shortDescription =
        fullDescription.slice(0, maxDescriptionCharacters - 3) + '...'
      headInfo.description = shortDescription
    }

    return headInfo
  }

  const setHeadInfo = (headInfo: HeadInfo) => {
    const route = useRoute()

    const headHtmlAttrs: HtmlAttributes = {
      dir: 'ltr',
      lang: LangList['es-ES'],
    }

    const headInfoShortDescription = getHeadInfoShortDescription(headInfo)

    const fullRoute = routes().addDomain({ slug: route.path as string })
    const headLinkClean: Link[] = [
      { id: 'i18n-can', rel: 'canonical', href: fullRoute },
    ]

    const headMetaClean: Meta[] = [
      {
        id: 'i18n-og-url',
        property: 'og:url',
        content: fullRoute,
      },
      {
        id: 'i18n-og',
        property: 'og:locale',
        content: LangList['es-ES'].replace('-', '_'),
      },
    ]

    if (headInfo.robotsVisible) {
      const robots: Meta = {
        name: 'robots',
        content: 'all',
      }

      headMetaClean.push(robots)
    }

    const useHeadComposed = {
      htmlAttrs: headHtmlAttrs,
      link: headLinkClean,
      meta: headMetaClean,
    }

    useHead(useHeadComposed)

    useSeoMeta({
      title: headInfo.title,
      description: headInfoShortDescription.description,

      ogTitle: headInfo.title,
      ogDescription: headInfoShortDescription.description,
      ogImage: headInfo.images,
      ogType: 'website',
      ogSiteName: 'escapadarural.com',
      fbAppId: 107587905956663,

      twitterCard: 'summary_large_image',
      twitterSite: '@escapadarural',
      twitterCreator: '@escapadarural',
      twitterTitle: headInfo.title,
      twitterDescription: headInfoShortDescription.description,
      twitterImage: headInfo.images,
    })
  }

  return {
    setHeadInfo,
  }
}
